const strings = {
  header: {
    button: 'Ver detalles',
  },
  results: {
    emptySubTitle: 'Sin embargo, creemos que estos cursos podrían interesarte',
    empty: 'No hemos encontrado resultados para tu búsqueda',
    title: 'Tus resultados de búsqueda',
  },
  filters: {
    back: 'Volver',
    removeAll: 'QUITAR TODOS',
    filterBy: 'Ordenar por',
  },
  backToTop: 'Ir al tope de página',
};

export default strings;
